import useRenderer from '@hooks/useRenderer'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import ArticleBodyContentContext from '@contexts/articleBodyContent'
import { bodyStyle } from './bodyStyle'

type GenericWidget = Record<string, unknown> & {
  kind: string[]
}

interface BodyProps {
  content: GenericWidget[]
}

const StyledContainer = styled.article`
  ${bodyStyle}
`

const Body: FunctionComponent<BodyProps> = ({ content }) => {
  const Renderer = useRenderer()
  return (
    <ArticleBodyContentContext.Provider value={true}>
      <StyledContainer>
        <Renderer>{content}</Renderer>
      </StyledContainer>
    </ArticleBodyContentContext.Provider>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'body'],
  component: Body,
}

export default widget
